var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',[_vm._l((_vm.rois),function(roi){return [_c('g',{key:roi.id,attrs:{"transform":("translate(" + (roi.position.x) + " " + (roi.position.y) + ")")}},[_c('path',{class:{
                    shine: roi.shiny && _vm.withClass,
                    selected: _vm.isSelectedRoi(roi) && _vm.withClass,
                    highlighted: _vm.highlighted(roi) && _vm.withClass,
                    highlightedComment:
                        _vm.highlightedComment(roi) && _vm.withClass,
                },attrs:{"d":roi.shape.svg,"vector-effect":"non-scaling-stroke"},on:{"click":function($event){return _vm.onPathClicked(roi)}}})])]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }